// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"504f49ee","451":"34be5f50","455":"1b40e7d3","488":"6c32578a","977":"414ba09f"}[chunkId] + ".chunk.js";
};